import {Component} from 'react';
import '../../../css/styles.css';
import SavingsPolicyOptions from './datasets/savings_policy_options';
import SetupSavingsCardDisplay from './setup_savings_card _display';

class SetupSavingsCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: null,
            selected: false,
            errorsFound: false,
        }
        this.savingsPolicyData = SavingsPolicyOptions;
    }

    initializeFields(){
        this.savingsData = 
            this.savingsPolicyData.find(elem => elem.type === this.props.savingsInfo.savingsType);
    }

    render() {
        this.initializeFields();
        this.savingsOpened = true;
        if (this.props.savingsInfo.startDate === "" && this.props.savingsInfo.updated === false){
            this.savingsOpened = false;
        }
        this.featuresList = this.savingsData.featuresArr.join(", ");
    return <>
        <div className="card my-2 drop-shadow">
           <div className="card-header text-left">
             <span className="container m-0 p-0">
                <div className="text-right col-sm-11">    
                    <h5 className="text-center">{this.savingsData.longName}</h5> 
                </div>
                <div className="d-flex w-100 my-0 mx-0">
                    <SetupSavingsCardDisplay
                        savingsClass={this.props.savingsClass}
                        savingsInfo={this.props.savingsInfo}
                        callingProcess={"setupSavingsCard"}
                        currentGameDate={this.props.currentGameDate}
                    />
                </div>
                <div className="row mt-2">
                    <div className="col-sm-3"></div>
                        <div className="col-sm-8 ">
                            {this.savingsOpened   ?
                                <button className="fancy-button-dark-blue"  
                                    onClick={() => 
                                        this.props.displaySavingsModal(this.props.savingsInfo.savingsType)} >
                                    Make Changes to {this.savingsData.longName} 
                                </button> 
                            :
                                <button className="fancy-button-dark-blue ml-4"  
                                    onClick={() => 
                                        this.props.displaySavingsModal(this.props.savingsInfo.savingsType)} >
                                    Open a {this.savingsData.longName} 
                                </button> 
                            }
                        <div className="col-sm-1"></div>
                    </div>
                </div>
                  
                </span>
            
            </div>
        </div>
   
    </>
    }

componentDidMount(){
    this._isMounted = true;
    if (this._isMounted === true){
        this.setCardOpen();
    }
}

setCardOpen(){
    if (this.props.savingsNotFound === true){
        this.setState({open: true});
    }else{
        this.setState({open: false});
    }
}

componentWillUnmount(){
    if (this.timeout) clearTimeout(this.timeout);
}


}

export default SetupSavingsCard;